module.exports = __webpack_public_path__ + "img/result-type-wrapper-red-cloud.10951068.png";